<template>
    <div v-on:click='clicked'>
      <div class=" col-xs-8 col-xs-offset-2 csp-no-pad"><slot></slot></div>
      <div class="col-xs-2 csp-no-pad" v-if="facebookSigninLoading">
        <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
    </div>
</template>

<script>
/**
 * Include the Facebook SDK
 */
(function (d, s, id) {
  const fjs = d.getElementsByTagName(s)[0]

  if (d.getElementById(id)) { return }

  const js = d.createElement(s)
  js.id = id
  js.src = '//connect.facebook.net/en_US/sdk.js'
  fjs.parentNode.insertBefore(js, fjs)
}(document, 'script', 'facebook-jssdk'))

export default {
  name: 'fb-signin-button',
  props: {
    params: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    }
  },
  computed: {
    facebookSigninLoading: {
      get: function () {
        return this.$store.getters.facebookSigninLoading
      },
      set: function (newValue) {
        this.$store.commit('setFacebookSigninLoading', newValue)
      }
    }
  },
  mounted: function () {
    const fbParams = this.params.init

    window.fbAsyncInit = function () {
      if (!window.FB) {
        console.err('Facebook SDK not present.')
        return
      }

      if (!fbParams.appId) {
        console.err('params.init.appId must be specified.')
        return
      }

      window.FB.init(fbParams)
      window.FB.AppEvents.logPageView()
    }
  },
  methods: {
    clicked: function () {
      this.facebookSigninLoading = true // set the trigger for the loading icon
      window.FB.login((response) => {
        if (response.authResponse && response.status === 'connected') {
          this.$emit('success', response)
        } else {
          this.$emit('failure', response)
          this.$emit('error', response)
        }
      },
        this.params.login
      )
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Facebook.vue?3311d516